module.exports = __webpack_public_path__ + "e90478870ea2c7705218d0240e86b3e5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PW.svg
// module id = rrKU
// module chunks = 0